import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/print/workorder/:id',
      name: 'Print Work Order',
      component: () => import('@/containers/PrintWorkOrder')
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: () => import('@/containers/Full'),
      children: [
        {
          path: 'logout',
          name: 'Logout',
          meta: { auth: undefined },
          component: () => import('@/views/logout/Logout')
        },
        {
          path: 'login',
          name: 'Login',
          notFoundRedirect: function (transition) {
            if (Vue.auth.check()) {
              return window.location.search.includes('redirect') ? decodeURIComponent(window.location.search.split('redirect=')[1]) : '/dashboard'
            }
            return '/dashboard'
          },
          meta: { auth: false },
          component: () => import('@/views/login/Login')
        },
        {
          path: 'reset-password',
          name: 'ResetPassword',
          meta: { auth: false },
          component: () => import('@/views/login/ResetPassword')
        },
        {
          path: 'qlik',
          name: 'Qlik',
          meta: { auth: ['admin'] },
          component: () => import('@/views/Qlik')
        },
        {
          path: '/admin/users/',
          name: 'Admin',
          meta: { auth: ['admin'] },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/admin/users',
              name: 'Users',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/Users')
            },
            {
              path: '/admin/users/edit/:id',
              name: 'Edit User',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/EditUser')
            },
            {
              path: '/admin/users/delete/:id',
              name: 'Delete User',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/DeleteUser')
            },
            {
              path: '/customerlog',
              name: 'Customer Log',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/CustomerLog')
            },
            {
              path: '/admin/emailtemplate',
              name: 'Email Template',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/EmailTemplate')
            },
            {
              path: '/admin/emailtemplate/edit/:id',
              name: 'Edit Email Template',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/EditEmailTemplate')
            },
            {
              path: '/admin/articles',
              name: 'Articles',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/Articles')
            },
            {
              path: '/admin/articles/edit/:id',
              name: 'Edit Article',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/EditArticle')
            },
            {
              path: '/admin/articles/delete/:id',
              name: 'Delete Article',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/DeleteArticle')
            },
            {
              path: '/admin/customers',
              name: 'Customers',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/Customers')
            },
            {
              path: '/admin/customers/edit/:id',
              name: 'Edit Customer',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/EditCustomer')
            },
            {
              path: '/admin/customers/delete/:id',
              name: 'Delete Customer',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/DeleteCustomer')
            },
            {
              path: '/admin/customers/edit/:id/edit/:contact_id',
              name: 'Edit Customer Contact',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/EditCustomerContact')
            },
            {
              path: '/admin/customers/edit/:id/delete/:contact_id',
              name: 'Delete Customer Contact',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/DeleteCustomerContact')
            },
            {
              path: '/admin/revisions',
              name: 'Revisions',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/Revisions')
            },
            {
              path: '/admin/revisions/delete/:id',
              name: 'Delete Revision',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/DeleteRevision')
            },
            {
              path: '/admin/equipment_specification',
              name: 'Equipment Specification',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/EquipmentSpecification')
            },
            {
              path: '/admin/equipment_specification/edit/:id',
              name: 'Edit Equipment Specification',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/EditEquipmentSpecification')
            },
            {
              path: '/admin/update_queue',
              name: 'Update Queue',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/UpdateQueue')
            },
            {
              path: '/admin/update_queue/delete/:id',
              name: 'Delete Update Queue',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/DeleteUpdateQueue')
            },
            {
              path: '/admin/pipes',
              name: 'Pipes',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/Pipes')
            },
            {
              path: '/admin/foam_weighing',
              name: 'Foam Weighing',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/FoamWeighing')
            },
            {
              path: '/admin/stock',
              name: 'Stock',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/Stock')
            },
            {
              path: '/admin/risk-questions',
              name: 'RiskQuestions',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/RiskQuestions')
            },
            {
              path: '/admin/risk-questions/edit/:id',
              name: 'EditRiskQuestion',
              meta: { auth: ['admin'] },
              component: () => import('@/views/admin/EditRiskQuestion')
            }
          ]
        },
        {
          path: '/admin/quickadd',
          name: 'Quick Add',
          component: () => import('@/views/admin/QuickAdd'),
          meta: { requiresAuth: true }
        },
        {
          path: '/admin/quickadd/edit/:id',
          name: 'Edit Quick Add',
          meta: { auth: ['admin'] },
          component: () => import('@/views/admin/EditQuickAdd')
        },
        {
          path: '/admin/quickadd/delete/:id',
          name: 'Delete Quick Add',
          meta: { auth: ['admin'] },
          component: () => import('@/views/admin/DeleteQuickAdd')
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          meta: { auth: true },
          component: () => import('@/views/Dashboard')
        },
        {
          path: '/workorder/',
          name: 'Work Orders',
          redirect: '/workorder/list',
          meta: { auth: ['admin', 'workorder'] },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/workorder/list',
              name: 'Work Order List',
              meta: { auth: ['admin', 'workorder'] },
              component: () => import('@/views/workorder/WorkorderList')
            }, {
              path: '/workorder/new',
              name: 'New',
              meta: { auth: ['admin', 'workorder'] },
              component: () => import('@/views/workorder/CreateWork')
            }, {
              path: '/workorder/mine',
              name: 'Mine',
              meta: { auth: ['admin', 'workorder'] },
              component: () => import('@/views/workorder/MyWorkorders')
            }, {
              path: '/workorder/jobreporting',
              name: 'Job Reporting',
              meta: { auth: ['admin', 'workorder'] },
              component: () => import('@/views/workorder/JobReporting')
            }, {
              path: '/workorder/readyforinvoicing',
              name: 'Ready For Invoicing',
              meta: { auth: ['admin', 'workorder'] },
              component: () => import('@/views/workorder/ReadyForInvoicing')
            }, {
              path: '/workorder/printed',
              name: 'Printed',
              meta: { auth: ['admin', 'workorder'] },
              component: () => import('@/views/workorder/Printed')
            }, {
              path: '/workorder/delete/:id',
              name: 'Delete Work Order',
              meta: { auth: ['admin', 'workorder'] },
              component: () => import('@/views/workorder/DeleteWorkorder')
            }, {
              path: '/workorder/edit/:id/:tab?',
              name: 'Single Work Order',
              meta: { auth: ['admin', 'workorder'], label: 'Order #' },
              component: () => import('@/views/workorder/edit/Index')
            }
          ]
        },
        {
          path: '/picklist/',
          name: 'Picklist',
          redirect: '/picklist/list',
          meta: { auth: ['admin', 'picklist'] },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/picklist/list',
              name: 'Picklist List',
              meta: { auth: ['admin', 'picklist'] },
              component: () => import('@/views/picklist/PicklistList')
            }, {
              path: '/picklist/new',
              name: 'New',
              meta: { auth: ['admin', 'picklist'] },
              component: () => import('@/views/picklist/NewPicklist')
            }, {
              path: '/picklist/draft',
              name: 'Draft',
              meta: { auth: ['admin', 'picklist'] },
              component: () => import('@/views/picklist/PicklistDraft')
            }, {
              path: '/picklist/printed',
              name: 'Printed',
              meta: { auth: ['admin', 'picklist'] },
              component: () => import('@/views/picklist/PicklistPrinted')
            }, {
              path: '/picklist/delete/:id',
              name: 'Delete Picklist',
              meta: { auth: ['admin', 'picklist'] },
              component: () => import('@/views/picklist/DeletePicklist')
            }, {
              path: '/picklist/edit/:id/:tab?',
              name: 'Single Picklist',
              meta: { auth: ['admin', 'picklist'], label: 'Picklist #' },
              component: () => import('@/views/picklist/edit/Index')
            }
          ]
        },
        {
          path: 'rental',
          name: 'Rentals',
          redirect: '/rental/list',
          meta: { auth: ['joint', 'admin'] },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/rental/list',
              name: 'All Rentals',
              meta: { auth: ['rentals', 'admin'] },
              component: () => import('@/views/rental/Index')
            }, {
              path: '/rental/new/:equipment_id?',
              name: 'New Rental',
              meta: { auth: ['rentals', 'admin'] },
              component: () => import('@/views/rental/NewRental')
            }, {
              path: '/rental/list/edit/:id',
              name: 'Edit Rental',
              meta: { auth: ['rentals', 'admin'] },
              component: () => import('@/views/rental/EditRental')
            }, {
              path: '/rental/equipment',
              name: 'Equipment',
              meta: { auth: ['rentals', 'admin'] },
              component: () => import('@/views/rental/Equipment')
            }, {
              path: '/rental/equipment/delete/:id',
              name: 'Delete Equipment',
              meta: { auth: ['rentals', 'admin'] },
              component: () => import('@/views/rental/DeleteEquipment')
            }, {
              path: '/rental/list/delete/:id',
              name: 'Delete Rental',
              meta: { auth: ['rentals', 'admin'] },
              component: () => import('@/views/rental/DeleteRental')
            }, {
              path: '/rental/equipment/edit/:id',
              name: 'Edit Equipment',
              meta: { auth: ['rentals', 'admin'] },
              component: () => import('@/views/rental/EditEquipment')
            }, {
              path: '/rental/equipmentmodel',
              name: 'Equipment Model',
              meta: { auth: ['rentals', 'admin'] },
              component: () => import('@/views/rental/EquipmentModel')
            }, {
              path: '/rental/equipmentmodel/delete/:id',
              name: 'Delete Equipment Model',
              meta: { auth: ['rentals', 'admin'] },
              component: () => import('@/views/rental/DeleteEquipmentModel')
            }, {
              path: '/rental/equipmentmodel/edit/:id',
              name: 'Edit Equipment Model',
              meta: { auth: ['rentals', 'admin'] },
              component: () => import('@/views/rental/EditEquipmentModel')
            }, {
              path: '/rental/equipmenttype',
              name: 'Equipment Type',
              meta: { auth: ['rentals', 'admin'] },
              component: () => import('@/views/rental/EquipmentType')
            }, {
              path: '/rental/equipmenttype/delete/:id',
              name: 'Delete Equipment Type',
              meta: { auth: ['rentals', 'admin'] },
              component: () => import('@/views/rental/DeleteEquipmentType')
            }, {
              path: '/rental/equipmenttype/edit/:id',
              name: 'Edit Equipment Type',
              meta: { auth: ['rentals', 'admin'] },
              component: () => import('@/views/rental/EditEquipmentType')
            }
          ]
        },
        {
          path: 'stock',
          name: 'Stock',
          redirect: '/stock',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/stock',
              name: 'Stock List',
              meta: { auth: ['admin', 'stock_checkin', 'stock_checkout', 'stock_admin', 'stock_list'] },
              component: () => import('@/views/stock/StockList')
            }, {
              path: '/stock/new',
              name: 'StockNew',
              component: () => import('@/views/stock/NewStock'),
              meta: { auth: ['admin', 'stock_checkout', 'stock_checkin', 'stock_admin'] }
            }
          ]
        },
        {
          path: 'flata',
          name: 'Fläta',
          redirect: '/flata',
          meta: { auth: ['flata', 'admin'] },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/flata',
              name: 'All Fläta',
              meta: { auth: ['flata', 'admin'] },
              component: () => import('@/views/flata/Index')
            }, {
              path: '/flata/new/',
              name: 'New Flata',
              meta: { auth: ['flata', 'admin'] },
              component: () => import('@/views/flata/NewFlata')
            }, {
              path: '/flata/edit/:id',
              name: 'Edit Flata',
              meta: { auth: ['flata', 'admin'] },
              component: () => import('@/views/flata/EditFlata')
            }
          ]
        },
        {
          path: 'equipment',
          name: 'Equipment',
          redirect: '/equipment/current',
          meta: { auth: ['joint', 'admin'] },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/equipment/current',
              name: 'Current Equipment',
              meta: { auth: ['joint', 'admin'] },
              component: () => import('@/views/equipment/Index')
            }, {
              path: '/equipment/historical',
              name: 'Equipment History',
              meta: { auth: ['joint', 'admin'] },
              component: () => import('@/views/equipment/Historical')
            }
          ]
        },
        {
          path: 'joint',
          name: 'Joint Log',
          meta: { auth: ['joint', 'admin'] },
          component: () => import('@/views/joint/Index')
        },
        {
          path: '/report/',
          name: 'Reports',
          redirect: '/report/new',
          meta: { auth: ['reportingv2', 'admin'] },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/report/new',
              name: 'New Report',
              meta: { auth: ['reportingv2', 'admin'] },
              component: () => import('@/views/report/NewReport')
            },
            {
              path: '/report/my-reports',
              name: 'My Reports',
              meta: { auth: ['reportingv2', 'admin'] },
              component: () => import('@/views/report/MyReports')
            },
            {
              path: '/report/all-reports',
              name: 'All Reports',
              meta: { auth: ['reportingv2', 'admin'] },
              component: () => import('@/views/report/MyReports')
            },
            {
              path: '/report/edit/:id',
              name: 'Edit Report',
              meta: { auth: ['reportingv2', 'admin'] },
              component: () => import('@/views/report/NewReport')
            }
          ]
        },
        {
          path: 'fieldwork',
          name: 'Fältläge',
          meta: { auth: ['admin', 'reportingv2', 'fieldmode'] },
          component: () => import('@/views/report/FieldWork')
        },
        {
          path: 'jointmachine',
          name: 'Joint Log Machine',
          meta: { auth: ['admin'] },
          component: () => import('@/views/joint/IndexMachine')
        },
        {
          path: '/knowledgebase',
          name: 'Knowledge Base',
          meta: { auth: ['admin'] },
          component: () => import('@/views/knowledgebase/Index')
        },
        {
          path: 'support',
          name: 'Support',
          meta: { auth: true },
          component: () => import('@/views/support/Index')
        },
        {
          path: 'user',
          redirect: '/user/profile',
          name: 'User',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/user/profile',
              name: 'User Profile',
              meta: { auth: true },
              component: () => import('@/views/user/Profile')
            }
          ]
        },
        {
          path: 'foam',
          name: 'Foam',
          meta: { auth: undefined },
          component: () => import('@/views/foam/Index')
        },
        {
          path: '404',
          name: 'Page404',
          meta: { auth: undefined },
          component: () => import('@/views/error/Page404')
        },
        {
          path: '500',
          name: 'Page500',
          meta: { auth: undefined },
          component: () => import('@/views/error/Page500')
        },
        {
          path: '403',
          name: 'Page403',
          meta: { auth: undefined },
          component: () => import('@/views/error/Page403')
        },
        {
          path: '/blueprint',
          name: 'Blueprint',
          component: () => import('@/views/blueprint/Blueprint'),
          meta: { auth: ['admin', 'blueprint'] }
        }
      ]
    },
    {
      path: '/joint/printreport',
      name: 'Joint Print Report',
      meta: { auth: ['joint', 'admin'] },
      component: () => import('@/views/joint/PrintReport')
    },
    {
      path: '/qlik/return',
      name: 'Qlik Return',
      component: () => import('@/views/QlikLoginReturn')
    },
    {
      path: '/change-expired-password',
      name: 'ChangeExpiredPassword',
      meta: { auth: true },
      component: () => import('@/views/login/ChangeExpiredPassword')
    }
  ]
})

router.onError((error) => {
  const isChunkLoadFailed = /Loading chunk [\w-]+ failed|ChunkLoadError|Loading CSS chunk/i.test(error.message)
  if (isChunkLoadFailed && !window.__chunkReloadAttempted) {
    window.__chunkReloadAttempted = true
    window.location.reload()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js